import Flickity from "flickity";

const initCarousel = () => {

    const carousel = document.querySelector('.js-carousel')

    if (carousel) {
        new Flickity(carousel, {
            cellAlign: 'center',
            contain: true,
            wrapAround: true,
            imagesLoaded: true,
            prevNextButtons: true,
            adaptiveHeight: true,
            pageDots: false,
            on: {
                ready: function() {
                    const prevBtn = carousel.querySelector('.flickity-button.previous')
                    const nextBtn = carousel.querySelector('.flickity-button.next')
                    const nav = document.querySelector('.c-carousel .js-nav');

                    nav.appendChild(prevBtn);
                    nav.appendChild(nextBtn);
                }
            }
        });
    }
}

export {initCarousel}
